import { apiFetchAuth } from "../../util/MainApiFetchTwo";

export async function postData(endpoint, body) {
  const fetchOptions = {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(body),
  };
  return await apiFetchAuth(endpoint, {}, fetchOptions);
}

export async function verifyAuth(body) {
  return await postData("/login/user_auth", body);
}

export async function getAppId(body) {
  return await postData("/login/app_id", body);
}

export async function verifyCaptchaLogin(body) {
  return await postData("/login/auth_captcha", body);
}

export async function verifyOTPLogin(body) {
  return await postData("/login/auth_otp", body);
}

export async function resendOTP(body) {
  return await postData("/login/resend_otp", body);
}
